import { GRAY, IRON, WHITE_BACKGROUND } from 'styles/Colors';
import BaseNavigation from 'portal/BaseNavigation';
import React from 'react';

const containerStyle = {
  backgroundColor: WHITE_BACKGROUND,
  borderRight: `1px solid ${GRAY}`,
  padding: '2rem 1rem',
  minHeight: '100%',
  display: 'flex',
  gap: '1.5rem',
  flexDirection: 'column',

  div: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.25rem',

    '&:not(:last-of-type)': {
      borderBottom: `1px solid ${IRON}`,
      paddingBottom: '1.5rem'
    }
  }
};

function SideNav({ navigate }) {
  return (
    <BaseNavigation
      navigate={navigate}
      containerId='sideNav'
      style={containerStyle}
    />
  );
}

export default SideNav;
